<template>
  <div class="controls">
    <LayoutButtonGroup v-for="itemGroup in controls.maximized">
      <FormButton
        v-for="item in itemGroup.group"
        :key="'CONTROL_' + item.name + '.' + getItemKey(item, 'value', false) + searchToken"
        :text="windowWidth < 640 ? false : (item.text ? item.text : false)"
        :textOnly="true"
        :value="windowWidth < 640 ? '' : getItemKey(item, 'value', false)"
        :color="getItemKey(item, 'color', false)"
        variant="dark"
        :bottomBorder="bottomBorder"
        :icon="windowWidth < 640 ? getItemKey(item, 'icon', false) : false"
        :iconSize="item.iconSize"
        :iconRotate="item.iconRotate ? item.iconRotate : false"
        :iconReversed="item.iconReversed ? item.iconReversed : false"
        :flipLayout="item.flipLayout ? item.flipLayout : false"
        :selected="getSetting(item.name) === getItemKey(item, 'value', true) || (getSetting(item.name) === 'dataset' && getItemKey(item, 'value', true) === 'datasets') || (getSetting(item.name) === 'pdf' && getItemKey(item, 'value', true) === 'pdfs') ? true : false"
        :disabled="false"
        @clicked="getSetting(item.name) === getItemKey(item, 'value', true) ? false : changeControl(item.name, getItemKey(item, 'value', false))"
      />
    </LayoutButtonGroup>
  </div>
</template>

<script>
import LayoutButtonGroup from '@/components/layout/ButtonGroup.vue'
import FormButton from '@/components/form/Button.vue'

export default {
  components: {
    LayoutButtonGroup,
    FormButton
  },
  props: {
    highlightColor: {
      type: String,
      default: '#1b1e21'
    },
    activeColor: {
      type: String,
      default: '#1593a6'
    },
    bottomBorder: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      controls: {
        'minimized': [{
          'group': [{
            'name': 'search.view',
            'value': 'datasets',
            'label': 'View all datasets',
            'text': 'View all',
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"/></svg>',
            'iconSize': 'md',
            'flipLayout': true,
            'color': 'blue'
          }]
        }],
        'maximized': [{
          'group': [{
            'name': 'search.view',
            'value': 'search',
            'label': 'View overview',
            'text': 'Overview',
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M6 6h-6v-6h6v6zm9-6h-6v6h6v-6zm9 0h-6v6h6v-6zm-18 9h-6v6h6v-6zm9 0h-6v6h6v-6zm9 0h-6v6h6v-6zm-18 9h-6v6h6v-6zm9 0h-6v6h6v-6zm9 0h-6v6h6v-6z"/></svg>',
            'iconSize': 'sm',
            'color': 'blue'
          },{
            'name': 'search.view',
            'value': 'datasets',
            'label': 'View datasets',
            'text': 'Datasets',
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M5 19h-4v-4h4v4zm6 0h-4v-8h4v8zm6 0h-4v-13h4v13zm6 0h-4v-19h4v19zm1 2h-24v2h24v-2z"/></svg>',
            'iconSize': 'lg',
            'color': 'blue'
          },{
            'name': 'search.view',
            'value': 'pdfs',
            'label': 'View reports',
            'text': 'Reports',
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" height="100%" width="100%" viewBox="0 0 24 24"><path d="M8.847 17.875c.191-.211.548-.431.801-.559-.152.3-.366.619-.544.792-.36.353-.556.095-.257-.233zm7.062-12.098c2.047-.478 4.805.28 6.091 1.179-1.494-1.997-5.23-5.708-7.432-6.882 1.156 1.168 1.563 4.235 1.341 5.703zm-4.769 10.21c.328-.109 1.036-.274 1.213-.315-.02-.021-.528-.544-.695-.832-.134.335-.509 1.127-.518 1.147zm.64-4.008c-.057-.278-.263-.299-.326.024-.057.296.029.771.129 1.061.113-.237.255-.805.197-1.085zm10.22-.979v13h-20v-24h8.409c4.857 0 3.335 8 3.335 8 3.009-.745 8.256-.42 8.256 3zm-6.98 4.413c-.526-.077-1.272.009-1.797.093-.385-.325-.866-.817-1.233-1.472.253-.652.415-1.168.483-1.536.354-1.919-1.979-2.072-1.729-.012.066.549.222 1.082.464 1.588-.286.709-.651 1.508-1.018 2.232-.811.307-1.396.627-1.742.954-1.212 1.143.295 2.661 1.438 1.014.274-.395.581-.955.811-1.396.717-.253 1.551-.475 2.33-.618.509.39 1.322.896 1.972.896 1.239.001 1.417-1.538.021-1.743zm-.104.704c-.2-.03-.488-.03-.829-.002.235.158.558.323.911.33.412.008.377-.26-.082-.328z"/></svg>',
            'iconSize': 'md',
            'color': 'blue'
          },{
            'name': 'search.view',
            'value': 'news',
            'label': 'View news',
            'text': 'News',
            'icon': '<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24"><path d="M21 9.662c-2.287.194-5.197 1.038-7 1.794v-1.064c1.933-.721 4.598-1.54 7-1.745v1.015zm0 2.031c-2.287.194-5.197 1.038-7 1.794v-1.064c1.933-.721 4.598-1.54 7-1.745v1.015zm0 2.031c-2.287.194-5.197 1.038-7 1.794v-1.064c1.933-.721 4.598-1.54 7-1.745v1.015zm0 2.031c-2.287.194-5.197 1.038-7 1.794v-1.064c1.933-.721 4.598-1.54 7-1.745v1.015zm0-9.951c-2.402.204-5.068 1.024-7 1.745v1.933c1.804-.756 4.713-1.6 7-1.794v-1.884zm-18 2.843c2.402.205 5.067 1.024 7 1.745v1.064c-1.803-.756-4.713-1.6-7-1.794v-1.015zm0 2.031c2.402.205 5.067 1.024 7 1.745v1.064c-1.803-.756-4.713-1.6-7-1.794v-1.015zm0 2.031c2.402.205 5.067 1.024 7 1.745v1.064c-1.803-.756-4.713-1.6-7-1.794v-1.015zm0 2.032c2.402.205 5.067 1.024 7 1.745v1.064c-1.803-.756-4.713-1.6-7-1.794v-1.015zm0-7.054c2.287.194 5.196 1.038 7 1.794v-1.933c-1.932-.72-4.598-1.54-7-1.744v1.883zm9-2.724c-3.063-1.671-7.776-2.755-12-2.963v17c4.289.206 8.195 1.249 12 3 3.805-1.751 7.711-2.794 12-3v-17c-4.224.208-8.937 1.292-12 2.963zm-10-.791c4.264.496 6.86 1.467 9 2.545v12.702c-2.968-1.184-5.939-1.95-9-2.271v-12.976zm20 12.975c-3.061.321-6.032 1.088-9 2.271v-12.701c2.187-1.103 4.757-2.051 9-2.544v12.974z"/></svg>',
            'iconSize': 'lg',
            'color': 'blue'
          }]
        }]
      }
    }
  },
  computed: {
    searchToken () {
      return this.$store.getters['search/getSearchToken']
    },
    settings () {
      return this.$store.getters['app/getSettings']
    },
    selectedControls () {
      return this.$store.getters['search/getSelectedControls']
    }
  },
  methods: {
    getSetting (name) {
      let parts = name.split('.')
      let mainSetting = parts[0]
      let subSetting = parts[1]

      return this.settings[mainSetting][subSetting]
    },
    getItemKey (item, type, flip) {
      if (Array.isArray(item[type])) {
        let parts = item.name.split('.')
        let mainSetting = parts[0]
        let subSetting = parts[1]
        let settingValue = this.settings[mainSetting][subSetting]

        if (settingValue === item.value[0]) {
          return item[type][flip ? 0 : 1]
        }

        return item[type][flip ? 1 : 0]
      }

      return item[type]
    },
    changeControl (name, value) {
      this.$emit('controlsChanged', name, value)
    },
    onResize() {
      this.windowWidth = window.innerWidth
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.nextItem)
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/app.scss';

.controls {
  display: flex;
  justify-content: flex-end;
  margin: 0 5px;
  height: 40px;

  @media screen and (min-width: $breakpointLg) {
    height: 44px;
  }
}

</style>
